<div class="z-10 appear">
  <div *ngIf="title" class="flex items-center justify-between pl-8 pr-8">
    <h2 class="font-sans text-eggplant-100 text-h500 md:text-h600 appear leading-none">{{ title }}</h2>
    <fun-new-button *ngIf="showNav" [buttonType]="'ghost'" [size]="'m'" title="Ver todos" icon="chevron-right" iconPosition="right" (eventClick)="verTodosClick.emit()"></fun-new-button>
  </div>

  <p *ngIf="subtitle" class="font-sans text-l text-eggplant-70 pt-16 pl-8 appear">{{ subtitle }}</p>
  <div class="appear pt-24">
    <div *ngIf="featured">
      <fun-new-card [isFlexibleCompensation]="isFlexibleCompensation" [project]="projectList[0]" [size]="'l'" [featured]="featured" [cardType]="cardType" (viewProjectEvent)="openNewProject(projectList[0])"></fun-new-card>
    </div>
    <div *ngIf="!featured" #sliderRow class="slider-row" (scroll)="onScroll()">
      <div *ngFor="let project of displayList" class="slider-card">
        <fun-new-card [isFlexibleCompensation]="isFlexibleCompensation" [project]="project" [size]="'l'" [featured]="featured" [cardType]="cardType" (viewProjectEvent)="openNewProject(project)"></fun-new-card>
      </div>
    </div>
    <div *ngIf="!featured && displayList.length > 1" class="flex justify-center gap-8 pt-16">
      <button *ngFor="let item of displayList; let i = index" class="slider-dot" [class.dot-active]="activeIndex === i" (click)="scrollToIndex(i)"></button>
    </div>
  </div>
</div>
